import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';

import { ReactiveFormsModule, FormControl, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs';
import { MfaPreferencesService } from '../mfa-preferences.service';
import { InternationalMobilePhoneComponent } from '@design/forms/international-phone/international-mobile-phone.component';
import { ButtonComponent } from '@design/buttons/button/button.component';
import { TestIdDirective } from '@design/core/test-id.directive';

@UntilDestroy()
@Component({
  selector: 'app-sms-mfa-configuration',
  templateUrl: './sms-mfa-configuration.component.html',
  styleUrl: './sms-mfa-configuration.component.scss',
  standalone: true,
  imports: [ReactiveFormsModule, InternationalMobilePhoneComponent, ButtonComponent, TestIdDirective]
})
export class SmsMfaConfigurationComponent implements OnInit {
  @Output() phoneUpdated = new EventEmitter<void>();
  protected formGroup = signal<UntypedFormGroup | null>(null);
  protected isUpdatingMfaPreferences = signal(false);

  constructor(
    private http: HttpClient,
    private mfaPreferencesService: MfaPreferencesService
  ) {}

  ngOnInit() {
    this.configureForm();
  }

  protected submitChanges() {
    const form = this.formGroup();
    if (!form?.valid) return;

    this.isUpdatingMfaPreferences.set(true);

    this.mfaPreferencesService
      .updateMfaPreferences({ mfaMethod: 'SMS', phoneNumber: form.get('phoneNumber')?.value })
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.isUpdatingMfaPreferences.set(false);
        })
      )
      .subscribe(() => {
        this.phoneUpdated.emit();
      });
  }

  private configureForm(): void {
    this.http
      .get<{ id: string; phoneNumber: string }>(environment.apiPaths.myAccount)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.formGroup.set(
          new FormGroup({
            id: new FormControl(user.id),
            phoneNumber: new FormControl(user.phoneNumber, Validators.required)
          })
        );
      });
  }
}
